export default function VerticalDivider() {
  return (
    <div className="tw-h-6 tw-border-r tw-border-neutral-200 tw-mx-4 tw-hidden md:tw-block" />
  );
}
